import getContentsDeFailureReason from './getContentsDeFailureReason'
import getDentalFailureReason from './getDentalFailureReason'
import getDogLiabilityFailureReason from './getDogLiabilityFailureReason'
import getDroneFailureReason from './getDroneFailureReason'
import getLegalFailureReason from './getLegalFailureReason'
import getLiabilityFailureReason from './getLiabilityFailureReason'

export const failureReasonAnalytics = {
  getDroneFailureReason,
  getLiabilityFailureReason,
  getContentsDeFailureReason,
  getDentalFailureReason,
  getDogLiabilityFailureReason,
  getLegalFailureReason,
}
